export function hashNumbers(...values: readonly number[]): number {
  let hash = 0x811c9dc5;
  for (const value of values) {
    let part = Math.trunc(value) | 0;
    for (let byte = 0; byte < 4; byte += 1) {
      hash ^= part & 0xff;
      hash = Math.imul(hash, 0x01000193);
      part >>= 8;
    }
  }
  hash ^= hash >>> 16;
  hash = Math.imul(hash, 0x21f0aaad);
  hash ^= hash >>> 15;
  hash = Math.imul(hash, 0x735a2d97);
  return (hash ^ (hash >>> 15)) >>> 0;
}

export class SeededRandom {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  next(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let value = this.state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4_294_967_296;
  }

  range(minimum: number, maximum: number): number {
    return minimum + (maximum - minimum) * this.next();
  }

  integer(minimum: number, maximumExclusive: number): number {
    return Math.floor(this.range(minimum, maximumExclusive));
  }
}
